import styled from "styled-components";
//css element for a button which is used multiple times in differnt components
const StyledButton = styled.button`
    display: inline-block;
    border: 0px solid #fff;
    border-radius: 10px;
    background: #475be8;
    padding: 15px 45px;
    color: white;
`;

export default StyledButton;